import { Collapse as AntCollpase } from 'antd';
import { FixedSizeList, FixedSizeListProps } from 'react-window';
import styled, { css } from 'styled-components';
import { ifNotProp, ifProp } from 'styled-tools';
import {
  Caption01,
  HelperText,
  ProductiveHeading06,
  SingleLineEllipsis,
  Text02,
} from 'components/styles';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 var(--spacing-05);
  overflow-x: auto;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin: var(--spacing-03);
`;

export const ColumnHeader = styled.div`
  padding: var(--spacing-03);
  min-height: var(--spacing-03);
  ${ProductiveHeading06};
  display: flex;
  align-items: center;
`;

export const ColumnBody = styled.div`
  width: 256px;
  min-height: calc(100vh - 260px);
  max-height: calc(100vh - 260px);
  overflow-y: auto;
  padding: var(--spacing-03);
  background-color: var(--coolest-gray-20);
`;

export const ColumnItem = styled.div`
  margin-bottom: var(--spacing-03);
`;

export const BoardContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HorizontalSwimLane = styled.div<{ $single?: boolean }>`
  display: flex;
  flex-direction: row;
  padding: 0 var(--spacing-05);
  overflow-x: auto;
  height: 100%;
  ${ifProp(
    '$single',
    css`
      padding-top: var(--spacing-05);
    `,
  )};
`;

type ListProps = FixedSizeListProps;

export const List = styled(FixedSizeList)<ListProps>`
  position: relative;
`;

export const ListTopSpacer = styled.div`
  min-height: var(--spacing-03);
  background-color: var(--coolest-gray-20);
`;

export const HeaderContainer = styled.div`
  width: 256px;
  margin: var(--spacing-03);
  ${ProductiveHeading06};
`;

export const Collapse = styled(AntCollpase)`
  & > .ant-collapse-item {
    border-color: var(--border-color);
  }

  & > .ant-collapse-item.ant-collapse-item-active {
    border-bottom: none;
  }

  & > .ant-collapse-item > .ant-collapse-header {
    padding: var(--spacing-03) var(--spacing-05);
    box-shadow: var(--shadow-01);
    background-color: var(--white-100);
    &:hover {
      background-color: var(--hover-color);
    }
  }
  & > .ant-collapse-item.ant-collapse-no-arrow > .ant-collapse-header {
    padding-left: var(--left-spacing);
  }

  .ant-collapse-content {
    background-color: inherit;
    border-top: none;
  }
`;

export const BoardColumnHeader = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  flex: 0 0 40px;
  justify-content: space-between;
`;

export const BoardColumnHeaderCount = styled.div`
  ${Text02};
  ${Caption01};
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  width: 40px;
  height: 40px;
`;

export const BoardColumnHeaderTitle = styled.div`
  ${SingleLineEllipsis};
  text-align: center;
  width: calc(100% - 80px);
  max-width: calc(100% - 80px);
`;

export const BoardColumnHeaderRightAction = styled.div`
  margin-left: auto;
`;

interface ColumnProps {
  $isDraggingOver: boolean | undefined;
  $isDragging: boolean | undefined;
  $isDropDisabled: boolean | undefined;
}

export const BoardColumnScrollableContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  position: relative;
  overflow-y: auto;
  padding: var(--spacing-03);
`;

export const BoardColumnScrollableContainerCardList = styled.div`
  flex: 1 0 100%;
  position: relative;
  width: 232px;
`;

export const SortableListItemContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
`;

export const SwimlaneHeaderSubTitle = styled.div`
  ${HelperText};
`;

export const BoardColumn = styled.div<Partial<ColumnProps>>`
  flex-direction: column;
  box-sizing: border-box;
  display: flex;
  flex: 0 0 256px;
  max-width: 256px;
  margin: 0 var(--spacing-03);
  position: relative;
  width: 256px;
  background-color: var(--coolest-gray-20);
  transition: background-color 0.4s ease;
  border: 2px dashed transparent;
  overflow: hidden;
  ${ifNotProp(
    '$isDropDisabled',
    css`
      ${ifProp(
        '$isDragging',
        css`
          background-color: var(--blue-10);
          border: 2px dashed var(--blue-60);
          ${BoardColumnScrollableContainer} {
            visibility: hidden;
          }
        `,
      )};

      ${ifProp(
        '$isDraggingOver',
        css`
          background-color: var(--green-10);
          border-color: var(--green-60);
          ${BoardColumnScrollableContainer} {
            visibility: hidden;
          }
        `,
      )};

      ${ifProp(
        '$draggingFromThisWith',
        css`
          background-color: var(--coolest-gray-20);
          border: none;
          ${BoardColumnScrollableContainer} {
            visibility: visible;
          }
        `,
      )};
    `,
  )};
`;
